import { render, staticRenderFns } from "./LegendPanelItem.vue?vue&type=template&id=96d66c86&scoped=true&"
import script from "./LegendPanelItem.vue?vue&type=script&lang=js&"
export * from "./LegendPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./LegendPanelItem.vue?vue&type=style&index=0&id=96d66c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d66c86",
  null
  
)

export default component.exports